import { render, staticRenderFns } from "./DeleteConfirmation.vue?vue&type=template&id=e1874a2c&scoped=true&"
import script from "./DeleteConfirmation.vue?vue&type=script&lang=js&"
export * from "./DeleteConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./DeleteConfirmation.vue?vue&type=style&index=0&id=e1874a2c&scoped=true&lang=stylus&"
import style1 from "./DeleteConfirmation.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1874a2c",
  null
  
)

export default component.exports